import { StyleSheet } from 'react-native'

export const fieldStyles = StyleSheet.create({
    splitFieldsRow: {
        flexDirection: 'row',
        width: '100%',
        gap: 16,
    },
    splitFieldsRowCompact: {
        gap: 12,
    },
    timeField: {
        width: 160,
    },
    timeFieldCompact: {
        width: 120,
    },
    customerField: {
        flex: 1,
        minWidth: 0,
    },
    topField: {
        zIndex: 1,
    },
    smallScreenField: {
        minWidth: 0,
        paddingHorizontal: 8,
    },
})
